import { render, staticRenderFns } from "./AvatarPreview.vue?vue&type=template&id=43b7e439"
import script from "./AvatarPreview.vue?vue&type=script&lang=js"
export * from "./AvatarPreview.vue?vue&type=script&lang=js"
import style0 from "./AvatarPreview.vue?vue&type=style&index=0&id=43b7e439&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports